
// import AcademiatvBanner from '~/components/AcademiatvBanner.vue'
import MediasetBanner from '~/components/slices/MediasetBanner.vue'
export default {
  name: 'DynamicSlice',
  props: ['slice'],
  components: { MediasetBanner }
}

